<script setup>
import { computed, getCurrentInstance } from 'vue';

// Component Imports
import ThemesEditorSectionMenu from './ThemesEditorSectionMenu';
import ThemesEditorCssGroupsMenu from './ThemesEditorCssGroupsMenu';
import ThemesEditorAddBtn from './ThemesEditorAddBtn';
import ThemesEditorSearchBtn from './ThemesEditorSearchBtn';
import ThemesEditorNavSection from './ThemesEditorNavSection';
import Button from "../../common/Button.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const activeCssGroupName = computed(() => store.state.themes.activeCssGroupName);
const activeEditorKey = computed(() => store.state.themes.activeEditorKey);
const cssGroupNames = computed(() => store.state.themes.cssGroupNames);
const items = computed(() => store.state.themes.items);
const sectionName = computed(() => store.state.themes.sectionName);
const tableName = computed(() => store.state.themes.tableName);
</script>

<template>
    <div class="h-100 px-2">
        <header class="d-flex align-items-center py-2">

            <div class="flex-fill">
                <ThemesEditorSectionMenu/>
                <ThemesEditorCssGroupsMenu/>
            </div>

            <div class="dropdown">
                <Button class="btn-sm" data-bs-toggle="dropdown">
                    <i class="bi-three-dots"/>
                </Button>

                <div class="dropdown-menu dropdown-menu-end">
                    <ThemesEditorAddBtn/>
                    <ThemesEditorSearchBtn/>
                </div>
            </div>
        </header>

        <ThemesEditorNavSection/>
    </div>
</template>